import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

async function sendNotification(data) {
    const headers = await getAuthHeader();
    const response = await fetch(`${API_URL}/p/newsletter`, {
        method: 'POST',
        headers: {
            ...jsonHeaders,
            ...headers
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}

async function saveClients(data, authHeader) {
    return await fetchAndParse(`${API_URL}/p/notifications`, {
        method: 'PUT',
        headers: {
            ...jsonHeaders,
            ...authHeader
        },
        body: JSON.stringify(data)
    });
}

export const useNewsletter = ({ setIsSending }) => {
    return useMutation({
        mutationFn: sendNotification,
        onError: (error) => {
            toast.error(error.message);
            setIsSending(false);
        },
        onSuccess: () => {
            toast.success(_t.global.success());
            setIsSending(false);
        }
    });
};

export function useClients(handleClose, setClients) {
    return useAuthMutation({
        mutationFn: saveClients,
        onError: (error) => {
            toast.error(error.message);
        },
        onSuccess: (res) => {
            toast.success(_t.global.success());
            setClients(res.model.notifications);
            handleClose();
        }
    });
}

export default useNewsletter;
